.consultFormHeading {
    color: #3caeb0;
    font-size: 50px;
    line-height: 1.1em;
}

.link {
    text-decoration: none;
    color: #3caeb0;
    font-size: 18px;
}

@media (max-width: 767px) {
    .consultFormHeading {
        font-size: 32px;
    }
}
